import { FormControlLabel, Radio, RadioGroup, Tooltip, Typography } from '@mui/material';
import { AudienceType } from 'domains/campaigns/types';

type AudienceTypeSelectorProps = {
    audienceType: AudienceType;
    onAudienceTypeChange: (type: AudienceType) => void;
    disableCohort?: boolean;
    cohortTooltip?: string;
};

const AudienceTypeSelector = ({
    audienceType,
    onAudienceTypeChange,
    disableCohort = false,
    cohortTooltip = '',
}: AudienceTypeSelectorProps) => (
    <RadioGroup value={audienceType} onChange={(e) => onAudienceTypeChange(e.target.value as AudienceType)} row>
        <FormControlLabel
            value={AudienceType.AUDIENCE}
            control={<Radio size="small" color="secondary" />}
            label={<Typography variant="body1">Audience</Typography>}
        />
        <Tooltip title={cohortTooltip} placement="top">
            <span>
                <FormControlLabel
                    value={AudienceType.COHORT}
                    control={<Radio size="small" color="secondary" />}
                    label={
                        <Typography variant="body1" sx={{ color: disableCohort ? 'text.disabled' : 'inherit' }}>
                            Cohort
                        </Typography>
                    }
                    disabled={disableCohort}
                />
            </span>
        </Tooltip>
    </RadioGroup>
);

export default AudienceTypeSelector;
